import { render } from "./uploadCardsFrom.vue?vue&type=template&id=dfbedb7a&scoped=true"
import script from "./uploadCardsFrom.vue?vue&type=script&lang=js"
export * from "./uploadCardsFrom.vue?vue&type=script&lang=js"

import "./uploadCardsFrom.vue?vue&type=style&index=0&id=dfbedb7a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfbedb7a"]])

export default __exports__